import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import RichText from '@/components/ui/RichText/RichText';
import type { Article } from './types';

export default function ArticleTitle({
  article,
  level = 1,
}: {
  article: Article;
  level?: 1 | 3;
}) {
  const styles =
    level === 1
      ? (article.title.topicsStyles ?? article.title.styles)
      : article.title.styles;
  if (article.section !== 'health-blog')
    return <RichText styles={styles}>{article.title.content}</RichText>;
  const Heading = level === 1 ? 'h1' : 'h3';
  const content = article.title.content.replace(
    /^(#{1,6})\s+(.+)$/gm,
    (_, hashes: string, text: string) =>
      `<span class="block ${styles?.[`h${hashes.length}`] ?? ''}">${text}</span>`,
  );

  return (
    <Heading>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        components={{
          p: ({ children }) => <span className={styles?.p}>{children}</span>,
          strong: ({ children }) => (
            <strong className={styles?.strong}>{children}</strong>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </Heading>
  );
}
